import actionTypes from '../constants/action-types';

const clientsState = {
  clients: null,
  count: null,
  showConvertUserModal: false,
  user: null,
  showExportTableModal: false,
};

export const clientsReducer = (state = clientsState, payload) => {
  switch (payload.type) {
    case actionTypes.HANDLE_SUCCESS_GET_CLIENTS:
      return { ...state, clients: payload.data.results, count: payload.data.count };
    case actionTypes.TOGGLE_CONVERT_USER_MODAL:
      return { ...state, showConvertUserModal: payload.data.show, user: payload.data.user };
    case actionTypes.TOGGLE_EXPORT_TABLE_MODAL:
      return { ...state, showExportTableModal: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/clients/reducers/clients-reducer.js